import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import style from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/i18n';

export default function Comp() {
    const { t } = useLang('theProduct.SectionH');
    const { locale = 'us' } = getLocal();

    const data = [
        { title: t('item_title1'), desc: t('item_desc1'), pc: 'https://websiteoss.ecoflow.com/upload/image/1744784871683/1.jpg' },
        {
            title: t('item_title2'),
            desc: t('item_desc2'),
            pc:
                locale === 'us'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1744784872049/2.jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1744784871867/2-ss.jpg',
        },
    ];

    return (
        <>
            <EcoSectionCommon className={style.title} title={t('title')} />
            <EcoSpaceSmall />
            <div className={style.comp}>
                {data.map((i) => (
                    <div className="item" key={i.title}>
                        <div className="title">{i.title}</div>
                        <img className="image" src={i.pc} loading="lazy" />
                        <div className="desc">{i.desc}</div>
                    </div>
                ))}
            </div>
        </>
    );
}
